import type { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { replaceAsset, uploadAssets } from '../asset-uploader/index.js';
import { deleteContent } from '../content/index.js';
import { waitForIndexing } from '../content/saga/persistence.js';
import { type ContentSearchState, getSearchState, search } from '../content-search/index.js';
import { deleteSelected, deleteSelectedPending, toggleAll, toggleAllFulfilled } from './actions.js';
import { LIBRARY_SEARCH_NAME, SHAPE_ID } from './constants.js';
import type { AssetsState } from './reducer.js';
import { getState } from './selectors.js';

export function* searchAssetsSaga(): SagaIterator {
  yield call(waitForIndexing, SHAPE_ID);
  yield put(
    search.requested({ searchName: LIBRARY_SEARCH_NAME })({
      shapeIds: [SHAPE_ID]
    })
  );
}

export function* deleteSelectedSaga(): SagaIterator {
  const state: AssetsState = yield select(getState);
  yield put(deleteSelectedPending());
  yield all(
    state.selected.map((id) =>
      put(
        deleteContent.requested(undefined, {
          contentId: id,
          shapeId: SHAPE_ID,
          locale: ''
        })
      )
    )
  );
}

export function* toggleAllSaga(): SagaIterator {
  const searchState: ContentSearchState = yield select(getSearchState, {
    searchName: LIBRARY_SEARCH_NAME
  });
  yield put(toggleAllFulfilled(searchState.results.map((result) => result._id)));
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(deleteSelected, deleteSelectedSaga),
    takeLatest(uploadAssets.FULFILLED, searchAssetsSaga),
    takeLatest(replaceAsset.FULFILLED, searchAssetsSaga),
    takeLatest(toggleAll, toggleAllSaga)
  ]);
}
